import { api, apitest } from '../api.request';

//年度退货次品占比
const proportionOfDefectiveProductsReturned = function() {
        return apitest.get("/qualityInspection/proportionOfDefectiveProductsReturned")
    }
    //面料质检跟踪
const get2 = function(o) {
        return api.get("/quality_testing/get2", o)
    }
    //面料质检跟踪2
const get3 = function(o) {
    return api.get("/quality_testing/get3", o)
}

// 主要退货质量问题分析
const analysisOfMainReturnQualityProblems = function() {
    return apitest.get("/qualityInspection/analysisOfMainReturnQualityProblems")
}

// 退货质量问题占比
const proportionOfReturnQualityProblems = function() {
    return apitest.get("/qualityInspection/proportionOfReturnQualityProblems")
}

export default {
    proportionOfDefectiveProductsReturned,
    analysisOfMainReturnQualityProblems,
    proportionOfReturnQualityProblems,
    get2,
    get3,
}